export var PARAMS = {
  h1: {
    size: 44,
    sizeM: 32,
    lineHeight: 's',
    weight: 'bold',
    as: 'h1'
  },
  h2: {
    size: 32,
    sizeM: 28,
    lineHeight: 's',
    weight: 'bold',
    as: 'h2'
  },
  h3: {
    size: 28,
    lineHeight: 's',
    weight: 'bold',
    as: 'h3'
  },
  h4: {
    size: 24,
    lineHeight: 's',
    weight: 'bold',
    as: 'h4'
  }
};